import { render, staticRenderFns } from "./OpenBroadcastsList.vue?vue&type=template&id=4a48ee04&scoped=true&"
import script from "./OpenBroadcastsList.vue?vue&type=script&lang=js&"
export * from "./OpenBroadcastsList.vue?vue&type=script&lang=js&"
import style0 from "./OpenBroadcastsList.vue?vue&type=style&index=0&id=4a48ee04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48ee04",
  null
  
)

export default component.exports